import React, { memo } from 'react'
import Grid from 'transfix-ui/core/Grid'
import AdditionalOptionsFormSection from '../AdditionalOptionsFormSection'
import LoadUnloadFormSection from '../LoadUnloadFormSection'
import SecuringOptionsFormSection from '../SecuringOptionsFormSection'
import TrailerQualityFormSection from '../TrailerQualityFormSection'
import DownloadReportFormSection from './DownloadReportFormSection'
import ReeferFlowFormSection from './ReeferFlowFormSection'
import ReeferTemperatureFormSection from './ReeferTemperatureFormSection'

export interface IReeferEquipmentFormSectionProps {}

const ReeferEquipmentFormSection = memo<IReeferEquipmentFormSectionProps>(() => {
  return (
    <Grid container spacing={2} data-test='reefer-equipment-form-section'>
      <Grid item xs={12} md={6} lg={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ReeferTemperatureFormSection />
          </Grid>
          <Grid item xs={12}>
            <ReeferFlowFormSection />
          </Grid>
          <Grid item xs={12}>
            <DownloadReportFormSection />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6} lg={4}>
            <SecuringOptionsFormSection />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TrailerQualityFormSection />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <LoadUnloadFormSection />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <AdditionalOptionsFormSection />
      </Grid>
    </Grid>
  )
})

export default ReeferEquipmentFormSection
